export class Person {
  id: number;
  name: string;
  company: string;
  address: string;
  email: string;
  mobile: string;
  country: Country;
  admin: boolean;
  active: boolean;
  client_key: string;
  client_secret: string;
  credits: number;
  credits_promo: number;
  credits_promo_end: Date;
  remind_low_balance: boolean;
  threshold_low_balance: number;
  client_version: string;
  tawkto_hash: string;

  constructor() {
    this.id = 0;
    this.name = '';
    this.company = '';
    this.address = '';
    this.email = '';
    this.mobile = '';
    this.country = new Country();
    this.admin = false;
    this.active = false;
    this.client_key = '';
    this.client_secret = '';
    this.credits = 0;
    this.credits_promo = 0;
    this.credits_promo_end = null;
    this.remind_low_balance = false;
    this.threshold_low_balance = 0;
    this.client_version = '';
    this.tawkto_hash = '';
  }

  creditsTotal(): number {
    return this.credits + this.credits_promo;
  }
}

export class Country {
  id: number;
  name: string;
  name_short: string;
  code: string;

  constructor() {
    this.id = 0;
    this.name = '';
    this.name_short = '';
    this.code = '';
  }
}

